
import React from 'react';

import Confirmador from './Confirmador'



const TableRowSolicitudes = (props) => {
    const {solicitud} = props;
    let nombreEmpresa= ""
    let mostrarConfirmador = props.modalConfirmadorId == solicitud.solicitudId
    
    let estado = solicitud.SolicitudEstadoId
    let tipoSolicitud = solicitud.SolicitudTipoId
    let administradora = solicitud.marcaId

    let logo= " image-visa-logo"

    let estadoAMostrar
    let claseEstado = null
    let textoTooltip = ""

    let claseTipoSolicitud = ""

    let mostrarEditar = true
    let mostrarEliminar = true
    let mostrarConfirmar = true

    let listadoTarjetas = ""

    if(solicitud.Tarjetas && solicitud.Tarjetas.length > 0){
        //SI HAY TARJETAS SE ORDENAN ALFABÉTICAMENTE EN UN NUEVO ARREGLO Y SE USA EL MISMO PARA CONSTRUIR UN STRING PARA EL TOOLTIP DE "INTEGRANTES"
        let arrTarjetasOrdenado=[]
        solicitud.Tarjetas.map(t=>arrTarjetasOrdenado.push(t.Apellido+", "+t.Nombre));
        arrTarjetasOrdenado.sort()
        arrTarjetasOrdenado.map(tarjeta=> {
            listadoTarjetas+=  "- " +tarjeta+"\n"
        })
    }
   
    //SE UBICA EL TOOLTIP DE ESTADO AL PIE DEL MISMO
    $(function () {
        $('[data-toggle="tooltip"]').tooltip({
        });
    });
    
    //SWITCH MARCA PARA LOGO DE LA IZQUIERDA DE LA TABLA
    switch(administradora){
        case 1:
            logo = " image-visa-logo"
        break;

        case 2:
            logo = " image-cabal-logo"
        break;

        case 3:
            logo = " image-mastercard-logo"
        break;
    }

    //SWITCH PARA ASIGNACIÓN DEL NOMBRE DE EMPRESA PARA SOLICITUDES DE CUENTA
    switch(tipoSolicitud){ 
        case 2: 
            if(solicitud.empresa){
                props.empresas && props.empresas.map(emp=>{if(emp.empresaId == solicitud.empresa)nombreEmpresa = emp.Denominacion})
            }
        break;
        case 3:
            if(solicitud.empresa){
                props.empresas && props.empresas.map(emp=>{if(emp.empresaId == solicitud.empresa)nombreEmpresa = emp.Denominacion})
            }
        break;
    }

    //SWITCH PARA ICONO DE TARJETA PREPAGA O DE CREDITO
    switch(solicitud.TipoProducto){
        case "TP":
            claseTipoSolicitud = " icon-tarjeta-prepaga"
        break;
        case "TC":
            claseTipoSolicitud = " icon-cuentas" 
        break;
        default: 
            claseTipoSolicitud = " icon-tarjeta-prepaga" 
        break;
    }

    //DE ACUERDO AL ESTADO SE ASIGNA LA ETIQUETA DE ESTADO, LA LEYENDA, EL TOOLTIP QUE LO EXPLICA Y LAS ACCIONES DISPONIBLES
    switch(estado){
        case 1:
            estadoAMostrar = "BORRADOR"
            claseEstado= "modal-news-modifications-button-gray-central-rectangle"
        break;

        case 2:
            estadoAMostrar = "COMPLETADO"
            claseEstado = "modal-news-modifications-button-lightblue-central-rectangle"
            textoTooltip = "Solicitud ingresada, a la espera de ser confirmada."
        break;

        case 3:
            estadoAMostrar = "CONFIRMADO"
            claseEstado = "modal-news-modifications-button-lightgreen-central-rectangle"
            textoTooltip =  "Solicitud confirmada, lista para ser enviada a Procesadora."
        break;

        case 4:
            estadoAMostrar = "DENEGADO"
            claseEstado = "modal-news-modifications-button-lightred-central-rectangle"
            textoTooltip = "Solicitud denegada por el supervisor."
        break;

        case 5:
            estadoAMostrar = "CTA. TC. ENV."
            claseEstado= "modal-news-modifications-button-gray-central-rectangle"
            mostrarConfirmar = false
            mostrarEditar = false
            mostrarEliminar = false
            textoTooltip = tipoSolicitud == 3 ? "Se envió solicitud de Adicional/Extensión a Procesadora, a la espera de respuesta.": "Se envió solicitud de Cuenta y Adicionales/Extensiones a Procesadora, a la espera de respuesta."
        break;

        case 6:
            estadoAMostrar = "CTA. TC. ACEP."
            claseEstado= "modal-news-modifications-button-gray-central-rectangle"
        break;

        case 7:
            estadoAMostrar = "CTA. TC. RECH."
            claseEstado="modal-news-modifications-button-board-central-rectangle"
            mostrarConfirmar = false
            mostrarEliminar = false
            textoTooltip = tipoSolicitud == 3 ? "Solicitud de Adicional/Extensión rechazada por Procesadora.": "Solicitud de Cuenta y Adicionales/Extensiones rechazada por Procesadora."
        break;

        case 8:
            estadoAMostrar = "EMP. ENVIADO"
            claseEstado= "modal-news-modifications-button-gray-central-rectangle"
            mostrarConfirmar = false
            mostrarEditar = false
            mostrarEliminar = false
            textoTooltip = "Solicitud de Empresa enviada a Prisma, a la espera de respuesta para enviar alta de Cuenta y Adicionales/Extensiones."
        break;

        case 9:
            estadoAMostrar = "EMP. ACEP."
            claseEstado= "modal-news-modifications-button-gray-central-rectangle"
            mostrarConfirmar = false
            mostrarEditar = false
            mostrarEliminar = false
            textoTooltip = "Solicitud de Empresa aceptada por Prisma, se enviará alta de Cuenta y Adicionales/Extensiones."
        break;

        case 10:
            estadoAMostrar = "CTA: TC:%"
            claseEstado= "modal-news-modifications-button-orange-central-rectangle"
            mostrarConfirmar = false
            mostrarEliminar = false
            textoTooltip = tipoSolicitud == 3 ? "La Procesadora aceptó al menos un Adicional/Extensión, pero rechazó al menos un Adicional/Extensión de la solicitud enviada.": "La Procesadora aceptó el alta de la Cuenta, pero rechazó al menos un Adicional/Extensión de la solicitud enviada."
        break;

        case 11:
            estadoAMostrar = "EMP. RECH."
            claseEstado="modal-news-modifications-button-board-central-rectangle"
            mostrarConfirmar = false
            mostrarEliminar = false
            textoTooltip = "Prisma rechazó el alta de la Empresa."
        break;
        
    }

    if(props.rowS!=""){
        
        return (
            <tr className="rowBordersVistaCliente">
                <td rowSpan={props.rowS} className="rowBordersVistaCliente" style={{verticalAlign: "middle",textAlign:"center"}}>
                    <label style={{marginTop: administradora == 2 ? "-10px" : "10px",marginBottom: administradora == 2 ? "-10px" : "5px"}} className={"rowTextVistaCliente"+logo}></label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className={"rowTextVistaCliente tdSolicitudes"+claseTipoSolicitud}></label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{solicitud.solicitudId}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{solicitud.cuentaTipoDescripcion}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{tipoSolicitud != 1 ? nombreEmpresa : solicitud.empresa}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{solicitud.descripcionCuenta}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label data-html="true" data-toggle="tooltip"  data-title={listadoTarjetas} className="rowTextVistaCliente white-tooltip conSaltoLinea" style={{color:"#00a5ff",marginTop:"0px",marginBottom:"0px"}}>{solicitud.Tarjetas.length + " TJ"}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label key={textoTooltip+props.solicitudId} data-toggle="tooltip"  data-title={textoTooltip} className={claseEstado + " white-tooltip tdSolicitudes"}>{estadoAMostrar}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{solicitud.FechaEstado && solicitud.FechaEstado.toLocaleString().split("T")[0]}</label>
                </td>
                <td className="hide" >
                    {mostrarEditar && <label onClick={()=>props.modificarSolicitud(solicitud)} style={{marginTop:"0px",marginBottom:"0px",marginRight:"5px",cursor:"pointer"}} className="hide"></label>}
                    {mostrarEliminar && <label onClick={()=>props.toggleModalConfirmador(solicitud.solicitudId,true)} style={{marginTop:"0px",marginBottom:"0px",marginRight:"5px",cursor:"pointer"}} className="rowTextVistaCliente icon-eliminar"></label>}
                    {mostrarConfirmar && <label onClick={()=>props.toggleModalConfirmador(solicitud.solicitudId,false)} style={{marginTop:"0px",marginBottom:"0px",cursor:"pointer"}} className="rowTextVistaCliente icon-confirmador22"></label>}
                    {mostrarConfirmador &&<Confirmador eliminaSolicitud={props.eliminaSolicitud} solicitudId={solicitud.solicitudId} cambiarEstadoSolicitud={props.cambiarEstadoSolicitud} estado={estado} modalId={props.modalConfirmadorId} cerrarModal={props.toggleModalConfirmador} />}
                </td>
            </tr>
        );
    }else{
        return (
            <tr className="rowBordersVistaCliente">
                <td className="rowBordersVistaClienteNoSides" >
                    <label className={"rowTextVistaCliente tdSolicitudes"+claseTipoSolicitud}></label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{solicitud.solicitudId}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{solicitud.cuentaTipoDescripcion}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{tipoSolicitud != 1 ? nombreEmpresa : solicitud.empresa}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{solicitud.descripcionCuenta}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label data-html="true" data-toggle="tooltip"  data-title={listadoTarjetas} className="rowTextVistaCliente white-tooltip conSaltoLinea" style={{color:"#00a5ff",marginTop:"0px",marginBottom:"0px"}}>{solicitud.Tarjetas.length + " TJ"}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label key={textoTooltip+props.solicitudId} data-toggle="tooltip"  data-title={textoTooltip} className={claseEstado + " white-tooltip tdSolicitudes"}>{estadoAMostrar}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" >
                    <label className="rowTextVistaCliente tdSolicitudes">{solicitud.FechaEstado && solicitud.FechaEstado.toLocaleString().split("T")[0]}</label>
                </td>
                <td  className="hide" >
                    {mostrarEditar && <label onClick={()=>props.modificarSolicitud(solicitud)} style={{marginTop:"0px",marginBottom:"0px",marginRight:"5px",cursor:"pointer"}} className="hide"></label>}
                    {mostrarEliminar && <label onClick={()=>props.toggleModalConfirmador(solicitud.solicitudId,true)} style={{marginTop:"0px",marginBottom:"0px",marginRight:"5px",cursor:"pointer"}} className="rowTextVistaCliente icon-eliminar"></label>}
                    {mostrarConfirmar && <label onClick={()=>props.toggleModalConfirmador(solicitud.solicitudId,false)} style={{marginTop:"0px",marginBottom:"0px",cursor:"pointer"}} className="rowTextVistaCliente icon-confirmador22"></label>}
                    {mostrarConfirmador &&  <Confirmador eliminaSolicitud={props.eliminaSolicitud} solicitudId={solicitud.solicitudId} cambiarEstadoSolicitud={props.cambiarEstadoSolicitud} estado={estado} modalId={props.modalConfirmadorId} cerrarModal={props.toggleModalConfirmador} />}
                </td>
            </tr>
        );

    }
}

export default TableRowSolicitudes;